import React from 'react';

import AssetLink from './AssetLink';
import AssignmentLink from './AssignmentLink';
import ComprehensionQuestion from './ComprehensionQuestion';

require('../../css/components/AssignmentSummary.scss');

'use strict';

export default class AssignmentSlat extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.onQuestionAnsweredCorrectly = this.onQuestionAnsweredCorrectly.bind(this);
        this.onQuestionAnsweredIncorrectly = this.onQuestionAnsweredIncorrectly.bind(this);
    }

    onQuestionAnsweredCorrectly() {
        this.setState({ selectedAnswer: true });

        if (this.props.onQuestionAnsweredCorrectly)
            this.props.onQuestionAnsweredCorrectly();
    }

    onQuestionAnsweredIncorrectly() {
        this.setState({ selectedAnswer: true });

        if (this.props.onQuestionAnsweredIncorrectly)
            this.props.onQuestionAnsweredIncorrectly();
    }

    render() {
        var assignment = this.props.assignment;
        var languageCode = this.props.languageCode;

        var question;
        var answers = [];
        var correctAnswer;

        var encounter = this.props.encounter;
        var assessment = encounter.assessment;

        if (assessment) {
            question = assessment.questions[0].textDx[this.props.languageCode];
            assessment.questions[0].answers.forEach(function (answer, i) {
                answers.push(answer.textDx[languageCode]);
                if (answer.correct)
                    correctAnswer = i;
            });
        }

        var copy = this.props.copy;

        return (
            !assignment.displayAsComplete || this.state.selectedAnswer || assignment.displayNextAssignment ?
                <div className="assignmentSummary">
                    {
                        !assignment.displayAsComplete && !this.state.selectedAnswer ?
                            <div>
                            {
                                assignment.displayProgress === 0 ?
                                    copy.assignmentLetsGetStarted :
                                    assignment.displayProgress > 0 && assignment.displayProgress < 1 ? 
                                        copy.assignmentYouveStarted :
                                        copy.assignmentYouveFinished
                            }
                            </div> :
                            null
                    }
                    {
                        !assignment.displayAsComplete && !this.state.selectedAnswer && assignment.displayResumeItem ?
                            <div>
                                {
                                    <AssetLink
                                        title={!assignment.displayProgress ? copy.assignmentStartWatching : copy.assignmentContinueWatching}
                                        className="btn btn-outline-primary btn-lg my-1"
                                        assignment={assignment} asset={assignment.displayResumeItem.asset}
                                        urlHash={this.props.urlHash}
                                        languageCode={this.props.languageCode}/>
                                }
                            </div> :
                            null
                    }
                    <div>
                        {
                            assignment.displayProgress && (!assignment.displayAsComplete || this.state.selectedAnswer) ?
                                React.createElement(
                                    ComprehensionQuestion,
                                    {
                                        copy: copy,
                                        question: question,
                                        answers: answers,
                                        correctAnswer: correctAnswer,
                                        selectedAnswer: this.state.selectedAnswer,
                                        onQuestionAnsweredCorrectly: this.onQuestionAnsweredCorrectly,
                                        onQuestionAnsweredIncorrectly: this.onQuestionAnsweredIncorrectly,
                                        answerFollowup: () => {
                                            return <div>
                                                <div>
                                                    Thank you for your feedback.
                                                </div>
                                                {
                                                    assignment.displayNextAssignment ?
                                                        <div>
                                                            <AssignmentLink
                                                                title={copy.assignmentContinueToNextAssignment}
                                                                className="btn btn-outline-primary btn-lg my-1"
                                                                assignment={assignment.displayNextAssignment}
                                                                url={this.props.url}
                                                                urlHash={this.props.urlHash}
                                                                languageCode={this.props.languageCode} />
                                                        </div> :
                                                        <div>
                                                            <div>
                                                                We have a great library! We invite you to check it out.
                                                            </div>
                                                            <a href={this.props.libraryUrl} className="btn btn-outline-primary btn-lg" role="button" aria-pressed="true">{copy.viewLibrary}</a>
                                                        </div>
                                                }
                                            </div>;
                                        }
                                    }
                                ) :
                                assignment.displayProgress ?
                                    assignment.displayNextAssignment ?
                                        <div>
                                            {
                                                <AssignmentLink
                                                    title={copy.assignmentContinueToNextAssignment}
                                                    className="btn btn-outline-primary btn-lg my-1"
                                                    assignment={assignment.displayNextAssignment}
                                                    url={this.props.url}
                                                    urlHash={this.props.urlHash}
                                                    languageCode={this.props.languageCode} />
                                            }
                                        </div> :
                                        <div>
                                            <div>
                                                We have a great library! We invite you to check it out.
                                            </div>
                                            <a href={this.props.libraryUrl} className="btn btn-outline-primary btn-lg" role="button" aria-pressed="true">{copy.viewLibrary}</a>
                                        </div> :
                                    null
                        }
                    </div>
                </div> :
                null
        );
    }
}